import { decodePasswordResetTokenExpiry } from './decodePasswordResetTokenExpiry';

export const isPasswordResetLinkExpired = (
  token: string | null | undefined,
  now: Date,
): boolean => {
  const expiresAt = decodePasswordResetTokenExpiry(token);

  return expiresAt !== undefined && expiresAt.getTime() <= now.getTime();
};
